export const FETCH_BEERS = 'FETCH_BEERS';
export const SET_BEERS = 'SET_BEERS';
export const ADD_BEERS = 'ADD_BEERS';
export const DRINK_BEERS = 'DRINK_BEERS';
export const REMOVE_BEER = 'REMOVE_BEER';
